export default {
    listing: state => state.listing
};
